import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const SafetyRankingRedirectPage = lazy(() => import('@cobliteam/safety-ranking/src/pages/SafetyRankingRedirectPage'));
const SafetyRankingPage = lazy(() => import('@cobliteam/safety-ranking/src/pages/SafetyRankingPage'));
const SafetyParametersPage = lazy(() => import('@cobliteam/safety-ranking/src/pages/SafetyParametersPage'));

const routes = [
  {
    path: Location.SAFETY_RANKING_ROOT,
    team: 'video-xp',
    component: SafetyRankingRedirectPage,
    accessDeniedDescription: 'Ver dados de modo de condução de motoristas',
    exact: true,
  },
  {
    path: Location.SAFETY_RANKING_TYPE,
    team: 'video-xp',
    component: SafetyRankingPage,
    accessDeniedDescription: 'Ver dados de modo de condução de motoristas',
    exact: true,
  },
  {
    path: Location.SAFETY_RANKING_PARAMETERS,
    team: 'video-xp',
    component: SafetyParametersPage,
    accessDeniedDescription: 'Ajuste de Parâmetros de modo de condução de motoristas',
    exact: true,
  },
];

export default routes;
